<template>
  <div class="dialog">
    <div class="dialog-content">
      <div class="dialog-content-close" @click="handleClose"></div>
      <div class="dialog-content-header">提示</div>
      <div class="dialog-content-body">
        <div class="dialog-content-body-content">{{ content }}</div>
      </div>
      <div class="dialog-content-footer">
        <div class="dialog-content-footer-button" @click="handleClose">
          我知道了
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  line-height: 1;
}
.dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 524px;
  height: auto;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 20px 35px;
  box-sizing: border-box;
  font-size: 26px;
  color: #333;
}
.dialog-content-close {
  position: absolute;
  right: 24px;
  top: 20px;
  width: 20px;
  height: 20px;
  background: url(@/assets/images/btn_close.png) no-repeat center center;
  background-size: 100% auto;
  cursor: pointer;
}
.dialog-content-header {
  padding-bottom: 15px;
  border-bottom: 1px solid #e6e4e4;
}
.dialog-content-body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  /* min-height: 200px; */
}
.dialog-content-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-content-footer-button {
  height: 40px;
  background: linear-gradient(90deg, #ff9900 0%, #ff7443 100%);
  border-radius: 50px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  padding: 0 30px;
  cursor: pointer;
}

@media (max-width: 1920px) {
  /* .dialog-content {
    width: 500px;
    font-size: 26px;
  }
  .dialog-content-close {
    width: 25px;
    height: 25px;
  }
  .dialog-content-header {
    padding-bottom: 25px;
  }
  .dialog-content-body {
    padding: 30px 0;
  }
  .dialog-content-footer-button {
    height: 50px;
    padding: 0 30px;
    line-height: 50px;
    border-radius: 30px;
    font-size: 24px;
  } */
}

@media (max-width: 1440px) {
  .dialog-content {
    width: 350px;
    padding: 15px;
    font-size: 18px;
  }

  .dialog-content-close {
    top: 14px;
    right: 16px;
    width: 14px;
    height: 14px;
  }
  .dialog-content-header {
    padding-bottom: 10px;
  }
  .dialog-content-body {
    padding: 30px 0;
  }
  .dialog-content-footer-button {
    height: 28px;
    padding: 0 18px;
    line-height: 28px;
    border-radius: 30px;
    font-size: 16px;
  }
}

/* @media (max-width: 1024px) {
  .dialog-content {
    width: 300px;
    height: 150px;
  }
}

@media (max-width: 768px) {
  .dialog-content {
    width: 200px;
    height: 100px;
  }
} */
</style>
